<template lang="pug">
v-dialog(:value="showing" @input="updateShowing"  :width="340")
  template(v-slot:activator="{on}")
    slot(name="activator" :open="open")  
      v-btn(x-small outlined color="primary" @click="open" v-show="!model.products || !model.products.length").text-capitalize add
  v-card
    v-card-title Select products
    v-card-text 
      v-autocomplete(
        v-model="selectedProducts" 
        label="Products" 
        multiple
        item-value="name" 
        item-text="name" 
        :items="products"
      )
    v-card-actions
      v-spacer
      v-btn(color="error" text @click="close") Close
      v-btn(color="success" :loading="processing" @click="update" text) Submit
</template>

<script>
import {mapGetters, mapActions} from "vuex"
import FormErrors from "@/util/form-errors"
export default {
  props: {
    model: Object,
    defaultProducts: Array
  },

  inject: ['svc'],

  data: () => ({
    showing: false,
    locations: [],
    selectedProducts: [],
    processing: false
  }),

  computed: {
    ...mapGetters({
      products: 'crmProductNames/items'
    })
  },

  methods: {
    updateShowing(isShowing) {
      this.showing = isShowing
    },
    setDefault() {
      this.selectedProducts = this.defaultProducts
    },

    open() {
      this.showing = true
      this.setDefault()
    },

    close() {
      this.showing = false
    },

    async update(data) {
      try {
        this.processing = true
        let res = await this.svc.updateProducts(this.model.ID, this.selectedProducts)
        this.$notify({text: 'Updated', type: 'success'})
        this.close()
        this.$emit('update', {ID: this.model.ID, products: this.selectedProducts})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.processing = false
      }
    }
  },
}
</script>